export default {
  labels: {
    custom: 'Indywidualny – dostępny na życzenie',
    was: 'Było {{amount}} – zastosowano rabat roczny',
  },
  tags: {
    preferred: 'Szczególnie popularny',
    net_one_time: 'netto jednorazowo',
    annual_discount: '-{{percentage}}% rocznie',
  },
  buttons: {
    select_plan: 'Wybierz ten plan',
  },
};
